<!-- 基础配置 -->
<template>
 <div class = 'basicConfig'>
    <div class = 'row'>
      <p class = 'title'>画布定位上</p>
      <p class = 'setvalue'>
        <el-input v-model="baseConfig.top"  @blur = 'handleclickblur'  placeholder="" />
      </p>
    </div>
    <div class = 'row'>
      <p class = 'title'>画布定位左</p>
      <p class = 'setvalue'>
        <el-input v-model="baseConfig.left"  @blur = 'handleclickblur'  placeholder="" />
      </p>
    </div>

    <div class = 'row'>
      <p class = 'title'>画布宽度</p>
      <p class = 'setvalue'>
        <el-input v-model="baseConfig.width"  @blur = 'handleclickblur'  placeholder="" />
      </p>
    </div>
    <div class = 'row'>
      <p class = 'title'>画布高度</p>
      <p class = 'setvalue'>
        <el-input v-model="baseConfig.height"  @blur = 'handleclickblur'  placeholder="" />
      </p>
    </div>
 </div>

</template>
<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import { useStore } from 'vuex';
export default {
 
  setup(props,ctx) {
      const store = useStore();

      
      const baseConfig = ref(
        {
            top:0,
            left:0,
            width:500,
            height:500,
            animation:'',
            type:'Blinechart'
        }
      )

      const handleclickblur = () =>{
        store.commit("baseConfigChange", baseConfig.value);
      };
      return{
        store,
        baseConfig,
        handleclickblur
      }


      
  }
}
</script>

<style scoped lang="less">


</style>